import { render, staticRenderFns } from "./update-patient-insurance.vue?vue&type=template&id=d9de6596&scoped=true"
import script from "./update-patient-insurance.vue?vue&type=script&lang=js"
export * from "./update-patient-insurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9de6596",
  null
  
)

export default component.exports